/**
 * Legacy PassesApiService module — preserved as an empty AngularJS module
 * so existing dependencies (`acme.common.service.passesApi`) keep resolving.
 *
 * The actual PassesApiService is now exposed through the Angular 18
 * ApiService facade. Implementation:
 *   apps/b2b-frontend/app/core/api/passes/passes-api.service.ts
 */
angular.module("acme.common.service.passesApi", [
  "acme.common.factory.apiVersion",
  "acme.common.factory.QueryStringBuilder",
]);
